import { Component, ViewEncapsulation } from "@angular/core";

@Component({
  selector: "lazy-loading",
  template: ` <div class="ui-h1">Should be large</div> `,
  styleUrls: ["./tailwind-css.element.scss"],
  encapsulation: ViewEncapsulation.ShadowDom,
})
export class TailwindCssElement {}
